export const branchOfficesInsertRules = {
  nombre: [{ required: true }],
  idEmpresa: [{ required: true }],
  region: [{ required: true }],
  comuna: [{ required: true }],
  habilitado: [{ required: true }],
};
